// extracted by mini-css-extract-plugin
export default {"defaultWrapper":"Title__defaultWrapper--1jp","defaultLoader":"Title__defaultLoader--4ii","item":"Title__item--2UY","placeHolderShimmer":"Title__placeHolderShimmer--3Nm"};